<template>
  <qx-card-form title="申请转移自有车司机">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        orgIdOptions: [],
        form: [
          {
            label: '申请说明',
            value: 'applyRemark',
            type: 'input',
            default: '123',
          },
          {
            label: '附件',
            value: 'applyFile',
            type: 'img',
            accept: 'image/*',
            fileSize: 5120,
            attr: {
              limit: 1,
            },
            default: [],
          },
        ],
        rules: {
          applyRemark: [ // 申请说明
            { required: true, message: '请输入申请说明', trigger: 'blur' },
          ],
          applyFile: [ // 联系人
            { required: true, message: '请上传附件', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      let formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData = {
          applyRemark: formData.applyRemark,
          applyFileId: formData.applyFile[0].id,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.$refs.baseForm.getVal();
      if (formData.applyFile && formData.applyFile[0]) {
        formData.applyFileId = formData.applyFile[0].id;
        formData.applyFileUrl = formData.applyFile[0].url;
      }
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.setVal('applyRemark', data.applyRemark || '');
      if (data.applyFileId) {
        this.$refs.baseForm.setVal('applyFile', [{
          id: data.applyFileId,
          url: data.applyFileUrl,
        }]);
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
